<template>
    <v-dialog
        :model-value="showModal"
        @update:model-value="closeErrorModal"
        :fullscreen="$vuetify.display.mobile"
        :max-width="$vuetify.display.mobile ? '100%' : '500'"
    >
        <v-card>
            <v-card-title class="headline">
                <div style="display: flex; justify-content: space-between; width: 100%;">
                    <span>Oh no, something went wrong!</span>
                    <v-btn icon @click="closeErrorModal">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </div>
            </v-card-title>
            <v-card-text>
                <p>The Old Ones prophesy this might be the issue:</p>
                <p><em>{{ errorMessage }}</em></p>
                <p>Please try again. If the issue keeps happening, please contact <a href="mailto:support@structure.io">support@structure.io</a>.</p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    name: 'ErrorModal',
    setup() {
        const store = useStore();
        const showModal = computed(() => store.state.showErrorModal);
        const errorMessage = computed(() => store.state.errorMessage);

        const closeErrorModal = () => {
            store.commit('SET_SHOW_ERROR_MODAL', false);
            store.commit('SET_ERROR_MESSAGE', null);
        };

        return {
            showModal,
            errorMessage,
            closeErrorModal,
        };
    }
};
</script>
